import type { ArticleAsset } from "./types";

function resolveSectionKey(asset: ArticleAsset) {
  if (asset.sectionId) return asset.sectionId;
  if (typeof asset.placement === "string") return asset.placement;
  return null;
}

export function createPlacementIndex(assets?: ArticleAsset[] | null) {
  const all = Array.isArray(assets) ? assets : [];
  const bySectionId = new Map<string, ArticleAsset[]>();
  const globalPlacements: ArticleAsset[] = [];

  for (const asset of all) {
    const key = resolveSectionKey(asset);
    if (!key || asset.placement === "global") {
      globalPlacements.push(asset);
      continue;
    }

    const existing = bySectionId.get(key) ?? [];
    existing.push(asset);
    bySectionId.set(key, existing);
  }

  return {
    bySectionId,
    globalPlacements,
  };
}
